module.exports = __webpack_public_path__ + "img/white_paper21.471b6155.png";